import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { makeStyles, Typography, Card, List, ListItem } from '@material-ui/core';
import { SearchResult } from './ocr';

interface TextAutoCompleteProps {
  options: SearchResult[];
  onSelect: (option: SearchResult) => void;
  onMouseEnter?: (option: SearchResult) => void;
  onMouseLeave?: () => void;
  autoFocusIndex?: number;
  onKeyDown?: (event: React.KeyboardEvent<any>) => void;
}

export default function TextAutoComplete(props: TextAutoCompleteProps) {
  const styles = useTextAutoCompleteStyles();
  if (!props.options.length) {
    return null;
  }
  return (
    <Card classes={{ root: styles.card }}>
      <div className={styles.header}>
        <MagicWand />
        <Typography component="span" classes={{ root: styles.heading }}>
          Magic Fill
        </Typography>
      </div>
      <List component="nav" onKeyDown={props.onKeyDown} onMouseLeave={props.onMouseLeave}>
        {props.options.map((option, index) => {
          const onClick = () => {
            props.onSelect(option);
          };
          const onMouseEnter = () => {
            if (props.onMouseEnter) {
              props.onMouseEnter(option);
            }
          };
          return (
            <ListItem
              autoFocus={index === props.autoFocusIndex}
              button
              key={index}
              onClick={onClick}
              onMouseEnter={onMouseEnter}
            >
              <Typography>{option.text}</Typography>
            </ListItem>
          );
        })}
      </List>
    </Card>
  );
}

function MagicWand() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.2001 3.99961L7.6001 3.19961L8.4001 2.79961L7.6001 2.39961L7.2001 1.59961L6.8001 2.39961L6.0001 2.79961L6.8001 3.19961L7.2001 3.99961ZM3.6001 5.59961L4.2666 4.26636L5.6001 3.59961L4.2666 2.93286L3.6001 1.59961L2.9336 2.93286L1.6001 3.59961L2.9336 4.26636L3.6001 5.59961ZM12.4001 8.79961L11.7336 10.1329L10.4001 10.7996L11.7336 11.4664L12.4001 12.7996L13.0666 11.4664L14.4001 10.7996L13.0666 10.1329L12.4001 8.79961ZM14.1656 3.95536L12.0443 1.83411C11.8883 1.67761 11.6836 1.59961 11.4788 1.59961C11.2741 1.59961 11.0693 1.67761 10.9131 1.83411L1.8346 10.9126C1.5221 11.2251 1.5221 11.7316 1.8346 12.0439L3.95585 14.1651C4.1121 14.3214 4.31685 14.3994 4.52135 14.3994C4.7261 14.3994 4.93085 14.3214 5.0871 14.1651L14.1656 5.08636C14.4781 4.77436 14.4781 4.26761 14.1656 3.95536ZM10.5863 6.68611L9.3136 5.41336L11.4786 3.24836L12.7513 4.52111L10.5863 6.68611Z" />
    </svg>
  );
}

const useTextAutoCompleteStyles = makeStyles({
  card: {
    paddingTop: '16px',
    margin: '16px 0',
    boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.15)',
    background: '#FFF',
  },
  header: {
    color: '#808080',
    padding: '0 16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  heading: {
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '16px',
    textTransform: 'uppercase',
    padding: '0 8px',
  },
});
